import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'

import {
    dateFormatFront,
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
    paymentTypeRosoom,
} from '@/custom/common/components'

import { useFormik } from 'formik'
import { Button, Divider } from '@mui/material'
import CartItem from './cartItem'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import Layout from '@/product/components/templates/Layout'
import './invoice.css'
import ProductContext from '@/product/context/product/productContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import * as Yup from 'yup'
import BarCodeScan from '@/product/components/organisms/BarCodeScan'
import AlertContext from '@/product/context/alert/alertContext'
import { useHistory } from 'react-router-dom'
import Loaders from '@/product/components/molecules/Loaders'

const InvoiceView = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables, currentLanguage } = customCommonContext

    const productContext = useContext(ProductContext)
    const {
        all_products,
        getAllProducts,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const invoiceContext = useContext(InvoiceContext)
    const {
        single_invoice,
        getSingleInvoice,
        updateInvoice,
        all_invoices,
        changeProductStatus,
        responseStatus: updateInvoiceResponseStatus,
    } = invoiceContext

    const alertContext = useContext(AlertContext)
    const history = useHistory()
    const { setAlert } = alertContext

    const [viewContent, setViewContent] = React.useState(null)
    const [print, setPrint] = useState(false)
    const [intialPickedupLoad, setIntialPickedupLoad] = useState(false)
    const [addMoreItems, setAddMoreItems] = useState(false)
    const [allActiveItems, setAllActiveItems] = useState([])
    const [scanToggle, setScanToggle] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [qtyOptions, setQtyOptions] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const data = props.data
    let invoiceID =
        props.winnerInvoiceId ||
        (props.match?.params?.id ? +props.match.params.id : 0)
    let userId =
        props.winnerUserId ||
        (props.match?.params?.uid ? +props.match.params.uid : 0)
    let action = props.match?.params?.action ? props.match.params.action : 0
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    // temp lang Manager
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    useEffect(() => {
        resetFrom()
    }, [props])

    useEffect(() => {
        setIsLoading(true)
        if (invoiceID && userId) {
            formik.values.invoice_id = invoiceID
            formik.values.user_id = userId

            if (action === 'cancel') {
                formik.values.filters = {
                    active: {
                        type: 'in',
                        field: 'b.active',
                        value: 2,
                    },
                }
            } else if (action === 'all') {
                formik.values.filters = {
                    active2: {
                        type: 'notin',
                        field: 'b.active',
                        value: 3,
                    },
                }
            } else {
                formik.values.filters = {
                    active: {
                        type: 'notin',
                        field: 'b.active',
                        value: 2,
                    },
                }
            }
            getSingleInvoice(formik.values, 'viewInvoice')
        }
        //  else {
        //     resetFrom()
        // }
    }, [invoiceID, userId, action])
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceUser: [],
        invoiceAddress: [],
    })

    useEffect(() => {
        if (single_invoice && single_invoice.from === 'viewInvoice') {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceTransactions: single_invoice.transactionrecords,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
            })
            setIsLoading(false)
            // formikCheckbox.values.picked_up = single_invoice.invoicerecords[0]
            //     .delivered
            //     ? true
            //     : false
        }
    }, [single_invoice])

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            invoiceUser: [],
            invoiceAddress: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceUser: [],
                invoiceAddress: [],
            })
        }
    }, [])
    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()
    const options = {}

    const generatePDF = (toPdf) => {
        setPrint(true)
        toPdf()
    }
    const completedPDF = () => {
        setPrint(false)
    }

    // const formikCheckbox = useFormik({
    //     initialValues: {
    //         picked_up: false,
    //     },
    //     onSubmit: (values) => {
    //         console.log('handle checked submit ', values)
    //     },
    // })

    // const mapDataOptions = {
    //     formik: formikCheckbox,
    //     data: [
    //         {
    //             label: 'Mark Item as Picked Up',
    //             type: 'checkbox',
    //             class: 'col-12',
    //             name: 'picked_up',
    //         },
    //     ],
    // }

    // useEffect(() => {
    //     if (data.id) {
    //         let payload = {
    //             action: formikCheckbox.values.picked_up
    //                 ? 'delivered'
    //                 : 'undelivered',
    //             project_id: [invoiceDetails.invoiceProducts[0]?.id],
    //         }
    //         if (intialPickedupLoad && payload.project_id[0]) {
    //             changeProductStatus(payload)
    //         }

    //         setIntialPickedupLoad(true)
    //     }
    // }, [formikCheckbox.values.picked_up, data.id])

    const addMoreItemsValidation = Yup.object({
        lpn_number: Yup.string().required('Required!'),
        project_id: Yup.number()
            .integer("Can't be a decimal")
            .required('Required!')
            .positive('Should be greater than 0'),
        qty: Yup.string().required('Required!'),
        // qty: Yup.number()
        //     .integer("Can't be a decimal")
        //     .required('Required!')
        //     .positive('Should be greater than 0')
    })

    const addMoreItemsFormik = useFormik({
        initialValues: {
            invoice_id: invoiceID,
            project_id: 0,
            user_id: userId,
            addMoreInvoiceItems: true,
            qty: '',
            lpn_number: '',
            product_title: '',
        },
        validateOnBlur: false,
        validationSchema: addMoreItemsValidation,
        onSubmit: (values) => {
            values.partial = invoiceDetails.cartValues.total_paid ? 1 : 0
            values.addMoreInvoiceItems = true
            console.log('added items ', values)
            updateInvoice(values)
        },
    })

    const clearAddMoreItemsFormik = () => {
        addMoreItemsFormik?.setValues(addMoreItemsFormik?.initialValues)
        addMoreItemsFormik?.setTouched({}, false)
        setQtyOptions([])
    }

    const handleCloseMoreItems = () => {
        clearAddMoreItemsFormik()
        setAddMoreItems(false)
    }

    const itemsQuantityField = [
        {
            label: 'Select Available Quantity',
            placeholder: 'Select Available Quantity',
            type: 'select',
            class: `${qtyOptions.length ? 'col-12' : 'd-none'}`,
            name: 'qty',
            size: 'small',
            formik: addMoreItemsFormik,
            options: qtyOptions,
        },
    ]

    const createArrayObjects = (num) => {
        return Array.from({ length: num }, (_, index) => ({
            show: index + 1,
            value: index + 1,
        }))
    }

    console.log('i am formik here', addMoreItemsFormik)

    useEffect(() => {
        if (updateInvoiceResponseStatus) {
            if (
                updateInvoiceResponseStatus.status === 'success' &&
                updateInvoiceResponseStatus.from === 'invoiceupdate'
            ) {
                if (addMoreItems) {
                    handleCloseMoreItems()
                    addMoreItemsFormik.setValues(
                        addMoreItemsFormik.initialValues
                    )
                    addMoreItemsFormik.setTouched({}, false)
                    getSingleInvoice(formik.values, 'viewInvoice')
                }
            }
        }
    }, [updateInvoiceResponseStatus])

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const handleScanProduct = () => {
        setScanToggle(true)
    }

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const setDecodedBarcode = (data) => {
        setSearchText(data)
        if (data && data !== '') {
            getAllProducts(
                {
                    limit: 1,
                    page: 1,
                    orderby: 'p.id, desc',
                    order: '',
                    filters: {
                        product_id: {
                            value: data,
                            type: 'in',
                            field: 'it.scan_lpn_number',
                        },
                        location: {
                            value: invoiceDetails.invoiceProducts[0]
                                ?.custom_projects_location,
                            type: 'in',
                            field: 'it.location',
                        },
                        buynow: {
                            value: 1,
                            type: 'in',
                            field: 'p.buynow',
                        },
                    },
                    market_status: ['open'],
                    having: {
                        future_active: {
                            value: '0',
                            type: 'in',
                            field: 'future_active',
                        },
                    },
                },
                'scan_lot'
            )
        }
    }

    const handleLpnInput = () => {
        console.log('i am handleLpnInput', addMoreItemsFormik.values.lpn_number)
        if (addMoreItemsFormik.values.lpn_number) {
            setDecodedBarcode(addMoreItemsFormik.values.lpn_number)
        } else {
            setAlert('LPN Number is required!', 'error')
        }
    }

    const handleLpnChange = (e) => {
        console.log('i am value', e)
        clearAddMoreItemsFormik()
        addMoreItemsFormik.setValues({
            lpn_number: e.target.value,
        })
    }

    const addMoreItemsFields = [
        {
            label: 'LPN Number',
            placeholder: 'Enter LPN Number',
            type: 'text',
            class: 'col-12',
            name: 'lpn_number',
            size: 'small',
            formik: addMoreItemsFormik,
            onChange: handleLpnChange,
            endAdornment: (
                <Button onClick={handleLpnInput}>
                    <span className="material-icons">search</span>
                </Button>
            ),
        },
    ]

    useEffect(() => {
        if (!addMoreItems) {
            handleCloseMoreItems()
        }
    }, [addMoreItems])

    useEffect(() => {
        if (
            all_products &&
            all_products.from === 'scan_lot' &&
            (searchText !== '' || addMoreItemsFormik.values.lpn_number !== '')
        ) {
            if (all_products?.records?.length) {
                const qtyOpt =
                    all_products?.records[0].qty - all_products?.records[0].sold
                addMoreItemsFormik.setValues({
                    project_id: all_products?.records[0].id,
                    lpn_number:
                        all_products?.records[0].scan_lpn_number.toString(),
                    invoice_id: invoiceID,
                    user_id: userId,
                    product_title: `${all_products?.records[0].title} (Available Qty - ${qtyOpt})`,
                })
                setQtyOptions(createArrayObjects(qtyOpt))
            } else {
                clearAddMoreItemsFormik()
                setAlert('LPN number not Found', 'error')
            }
        }
    }, [all_products])

    return (
        // <FullScreenPopup
        //     modaltitle={
        //         data.status === 'view' ? `VIEW INVOICE` : `EDIT INVOICE`
        //     }
        //     open={data.popup}
        //     handleClose={() => toggleFullScreenPopup(false)}
        // >
        <Layout>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <div className="container-lg productInvoice">
                    <h3 className="invoiceTitle">{t('tax_invoice')}</h3>
                    <div className="d-flex justify-content-between align-items-center mb-2 noPrint">
                        <Button
                            id="invoice_arrow_back"
                            onClick={() => {
                                history.goBack()
                                window.scrollTo(0, 0)
                            }}
                            className="moveBack"
                        >
                            <span className="material-icons">arrow_back</span>
                            {'Back'}
                        </Button>
                        {/* <Breadcrumbs aria-label="breadcrumb" className="naBreadcrumbs">
                        <Link to="/dashboard/won">Dashboard</Link>
                        <Typography color="textPrimary">Invoice</Typography>
                    </Breadcrumbs> */}
                        <Button
                            id="invoice_print"
                            onClick={() => window.print()}
                        >
                            <span className="material-icons">print</span>
                            {t('print')}
                        </Button>
                    </div>
                    <div
                        className={`invoiceView ${
                            print ? 'invoiceViewPrint' : ''
                        }`}
                        ref={ref}
                        style={{ height: '100%', width: '100%' }}
                    >
                        <div className="card-header d-flex justify-content-between align-items-center p-4">
                            <div className="col-md-12 text-left">
                                <a
                                    className="pt-2 d-inline-block"
                                    data-abc="true"
                                >
                                    <img
                                        src="/assets/images/logo_light.png"
                                        className="invLogo"
                                        alt={SITE_NAME}
                                        style={{ width: '240px' }}
                                    />
                                </a>
                                <div>
                                    <p className="text-dark  mt-2 mb-0">
                                        {SITE_NAME}
                                    </p>
                                    {props.topAddress ? props.topAddress : ''}
                                </div>
                            </div>

                            {/* <div className="float-right invDate">
                                <h5 className="mb-0">
                                    {t('invoice')} #
                                    {invoiceDetails.cartValues.common_invoice}{' '}
                                </h5>
                                {invoiceDetails.cartValues.cart_paiddate ||
                                invoiceDetails.invoiceProducts[0]
                                    ?.returned_date ? (
                                    <h5 className="mb-0">
                                        {t('date')}:{' '}
                                        {invoiceDetails.invoiceProducts[0]
                                            ?.active === 2
                                            ? dateTimeFormatFunction(
                                                  invoiceDetails
                                                      .invoiceProducts[0]
                                                      ?.returned_date
                                              )
                                            : dateTimeFormatFunction(
                                                  invoiceDetails.cartValues
                                                      .cart_paiddate
                                              )}
                                    </h5>
                                ) : null}
                                <h5 className="mb-0">
                                    {t('status')}:{' '}
                                    {invoiceDetails.invoiceProducts[0]
                                        ?.active === 2
                                        ? 'Cancelled'
                                        : invoiceDetails.cartValues.cart_paid
                                        ? 'Paid'
                                        : invoiceDetails.cartValues.total_paid
                                        ? 'Partial'
                                        : 'Unpaid'}
                                </h5>
                            </div> */}
                        </div>
                        <h2 className="text-center taxInvoiceHeader">
                            TAX INVOICE
                        </h2>
                        <div className="card-body">
                            <div className="row mb-4">
                                {invoiceDetails.invoiceUser?.length ? (
                                    <div
                                        className={`col-md-6 invAddr ${
                                            currentLanguage === 'for_arabic'
                                                ? 'text-right'
                                                : 'text-left'
                                        }`}
                                    >
                                        <p className="textBold">
                                            Customer Details
                                        </p>
                                        <p className="cstmrNameTxt">
                                            {
                                                invoiceDetails.invoiceUser[0]
                                                    .first_name
                                            }{' '}
                                            {
                                                invoiceDetails.invoiceUser[0]
                                                    .last_name
                                            }
                                        </p>

                                        <>
                                            {/* <div>
                                        {invoiceDetails.invoiceUser[0].address1 &&
                                            invoiceDetails.invoiceUser[0].address1}
                                    </div>
                                    <div>
                                        {invoiceDetails.invoiceUser[0].address2 &&
                                            invoiceDetails.invoiceUser[0].address2}
                                    </div> */}
                                            {invoiceDetails.invoiceUser[0]
                                                .city &&
                                                invoiceDetails.invoiceUser[0]
                                                    .state &&
                                                invoiceDetails.invoiceUser[0]
                                                    .country && (
                                                    <p>
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .city
                                                        }
                                                        ,{' '}
                                                        {/* {invoiceDetails.invoiceUser[0].state},{' '} */}
                                                        <br />
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .country
                                                        }{' '}
                                                        -{' '}
                                                        {
                                                            invoiceDetails
                                                                .invoiceUser[0]
                                                                .zip
                                                        }
                                                    </p>
                                                )}
                                        </>
                                    </div>
                                ) : null}
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <p className="m-0 textBold mobCls">
                                                Invoice Number
                                            </p>
                                        </div>
                                        <div className="col-md-1 textBold colon">
                                            :
                                        </div>
                                        <div className="col-md-6">
                                            <p className="m-0">
                                                {
                                                    invoiceDetails.cartValues
                                                        .common_invoice
                                                }
                                            </p>
                                        </div>
                                        <div className="col-md-5">
                                            <p className="m-0 textBold mobCls">
                                                Invoice Date
                                            </p>
                                        </div>
                                        <div className="col-md-1 textBold colon">
                                            :
                                        </div>
                                        <div className="col-md-6">
                                            <p className="m-0">
                                                {dateFormatFront(
                                                    invoiceDetails.cartValues
                                                        .cart_paiddate
                                                )}
                                            </p>
                                        </div>
                                        <div className="col-md-5">
                                            <p className="m-0 textBold mobCls">
                                                Invoice Status:
                                            </p>
                                        </div>
                                        <div className="col-md-1 textBold colon">
                                            :
                                        </div>
                                        <div className="col-md-6">
                                            <p className="m-0">
                                                {invoiceDetails
                                                    .invoiceProducts[0]
                                                    ?.active === 2
                                                    ? 'Cancled'
                                                    : invoiceDetails.cartValues
                                                          .cart_paid
                                                    ? 'Paid'
                                                    : 'Unpaid'}
                                            </p>
                                        </div>
                                        {/* <div className="col-md-5">
                                    <p className="m-0 textBold">Currency</p>
                                </div>
                                <div className="col-md-1 textBold">:</div>
                                <div className="col-md-6">
                                    <p className="m-0">$</p>
                                </div> */}
                                    </div>
                                </div>
                                {invoiceDetails.invoiceUser?.length ? (
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <p className="textBold d-flex justify-content-between mobSpecCls">
                                                    Phone
                                                </p>
                                            </div>
                                            <div className="col-md-1 textBold colon">
                                                :
                                            </div>
                                            <div className="col-md-6">
                                                <p>
                                                    {
                                                        invoiceDetails
                                                            .invoiceUser[0]
                                                            .phone
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {/* {invoiceDetails.appointmentDetail ? (
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-5">
                                        <p className="m-0 textBold">Appointment</p>
                                    </div>
                                    <div className="col-md-1 textBold">:</div>
                                    <div className="col-md-6">
                                        <p className="m-0">
                                            {dateTimeFormatFunction(
                                                invoiceDetails.appointmentDetail.appointmentTime,
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : null} */}
                                {invoiceDetails.invoiceUser?.length ? (
                                    <>
                                        <div className="col-md-2">
                                            <p className="textBold d-flex justify-content-between mobSpecCls">
                                                Email
                                                <span className="colon">:</span>
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <p>
                                                {
                                                    invoiceDetails
                                                        .invoiceUser[0].email
                                                }
                                            </p>
                                        </div>
                                        <div className="col-md-6"></div>
                                    </>
                                ) : null}
                            </div>
                            {/* {invoiceDetails.cartValues.cart_payment ? (
                        <>
                            <h4 className="invoiceSubTitle">
                                Payment Type:{' '}
                                {invoiceDetails.cartValues.cart_payment === 'online' ? (
                                    <>{t('online_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'offline' ? (
                                    <>{t('offline_payment')}</>
                                ) : invoiceDetails.cartValues.cart_payment === 'deposit' ? (
                                    <>{t('deposit')}</>
                                ) : null}
                            </h4>
                        </>
                    ) : null} */}
                            {/* 
                            {invoiceDetails.appointmentDetail ? (
                                <>
                                    <h4 className="invoiceSubTitle">
                                        {t('appointment_scheduled_at')}:{' '}
                                        {dateTimeFormatFunction(
                                            invoiceDetails.appointmentDetail
                                                .appointmentTime
                                        )}
                                    </h4>
                                </>
                            ) : null} */}
                            {invoiceDetails.invoiceProducts[0]?.active === 2 ? (
                                <>
                                    <h4 className="invoiceSubTitle text-danger">
                                        {'Invoice Cancelled: '}
                                        {
                                            invoiceDetails.invoiceProducts[0]
                                                ?.notes
                                        }
                                    </h4>
                                </>
                            ) : null}
                            {invoiceDetails.invoiceProducts[0]?.active === 0 ? (
                                invoiceDetails.invoiceProducts[0]?.partial ===
                                1 ? (
                                    <>
                                        <h4 className="invoiceSubTitle text-danger">
                                            {'Unpaid Invoice Notes: '}
                                            {
                                                invoiceDetails
                                                    .invoiceProducts[0]?.notes
                                            }
                                        </h4>
                                    </>
                                ) : (
                                    <>
                                        <h4 className="invoiceSubTitle text-danger">
                                            {'Unpaid Invoice Notes: '}

                                            {'Payment Not Initiated'}
                                        </h4>
                                    </>
                                )
                            ) : invoiceDetails.invoiceProducts[0]?.active ===
                              1 ? (
                                invoiceDetails.invoiceProducts[0]?.paid ===
                                0 ? (
                                    <>
                                        <h4 className="invoiceSubTitle text-danger">
                                            {'Unpaid Invoice Notes: '}
                                            {
                                                invoiceDetails
                                                    .invoiceProducts[0]?.notes
                                            }
                                        </h4>
                                    </>
                                ) : null
                            ) : null}

                            {invoiceDetails.invoiceTransactions.length ? (
                                <>
                                    <h4 className="invoiceSubTitle">
                                        {t('transaction_details')}
                                    </h4>
                                    {/* <div className="row">
                                    {mapData(mapDataOptions)}
                                </div> */}
                                    {/* <div className="d-flex justify-content-end mb-3">
                                        <Button
                                            variant="outlined"
                                            onClick={() =>
                                                setAddMoreItems(true)
                                            }
                                        >
                                            <span className="material-icons">
                                                library_add
                                            </span>
                                            {'Add Item'}
                                        </Button>
                                        {!invoiceDetails?.cartValues
                                            ?.cart_paid ? (
                                            <Button
                                                variant="outlined"
                                                className="ml-2"
                                                onClick={() =>
                                                    handleRedirectInternal(
                                                        history,
                                                        `invoice/payment/${invoiceID}/${userId}`
                                                    )
                                                }
                                            >
                                                <span className="material-icons">
                                                    monetization_on
                                                </span>
                                                {'Make Payment'}
                                            </Button>
                                        ) : null}
                                    </div> */}
                                    <div className="transDet d-flex justify-content-between flex-wrap">
                                        <>
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        {/* <th scope="col">S.No</th> */}
                                                        <th scope="col">
                                                            {t(
                                                                'transaction_id'
                                                            )}
                                                        </th>
                                                        <th scope="col">
                                                            {t('paid_on')}
                                                        </th>
                                                        <th scope="col">
                                                            {t('method')}
                                                        </th>
                                                        <th scope="col">
                                                            {t('amount')}
                                                        </th>
                                                        <th scope="col">
                                                            {t('status')}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoiceDetails.invoiceTransactions.map(
                                                        (data, index) => (
                                                            <tr key={index}>
                                                                <td
                                                                    data-title={t(
                                                                        'transaction_id'
                                                                    )}
                                                                >
                                                                    {data.trans_id
                                                                        ? `# ${data.trans_id}`
                                                                        : '-'}
                                                                </td>
                                                                <td
                                                                    data-title={t(
                                                                        'paid_on'
                                                                    )}
                                                                >
                                                                    {dateTimeFormatFunction(
                                                                        data.created_at
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={t(
                                                                        'card'
                                                                    )}
                                                                >
                                                                    {data.payment_method ===
                                                                        'offline' &&
                                                                    data.card_type ? (
                                                                        `${capitalize(
                                                                            data.payment_method
                                                                        )} - ${capitalize(
                                                                            data.card_type
                                                                        )}`
                                                                    ) : data.card_type ? (
                                                                        <>
                                                                            {paymentTypeRosoom(
                                                                                data.card_type,
                                                                                t
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        capitalize(
                                                                            data.payment_method
                                                                        )
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={t(
                                                                        'amount'
                                                                    )}
                                                                >
                                                                    {currencyFormat(
                                                                        data.amount
                                                                    )}
                                                                </td>
                                                                <td
                                                                    data-title={t(
                                                                        'payment_status'
                                                                    )}
                                                                    style={{
                                                                        color:
                                                                            data.status ===
                                                                            'success'
                                                                                ? 'green'
                                                                                : 'red',
                                                                    }}
                                                                >
                                                                    {capitalize(
                                                                        data.status
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </>
                                    </div>
                                </>
                            ) : null}
                            <h4 className="invoiceSubTitle mt-5">
                                {t('product_details')}
                            </h4>

                            <div className="table-responsive">
                                {invoiceDetails.invoiceProducts.length ? (
                                    <div className="cartProducts">
                                        <div>
                                            {invoiceDetails.invoiceProducts.map(
                                                (data, index) => (
                                                    <CartItem
                                                        data={data}
                                                        from="invoice"
                                                    />
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="row mt-5">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="table table-clear nellisInvTot">
                                            <tbody>
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('items')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {
                                                                invoiceDetails
                                                                    .invoiceProducts
                                                                    .length
                                                            }
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('subtotal')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .per_total
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            Time to Give Network
                                                            Fee
                                                            {invoiceDetails
                                                                .invoiceProducts
                                                                .length ? (
                                                                <>
                                                                    {' '}
                                                                    (
                                                                    {
                                                                        invoiceDetails
                                                                            .invoiceProducts[0]
                                                                            .tax_percent
                                                                    }
                                                                    % )
                                                                </>
                                                            ) : null}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_tax
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td
                                                        className="left"
                                                        align="right"
                                                    >
                                                        <span className="text-dark">
                                                            {t('total_amount')}
                                                        </span>
                                                    </td>
                                                    <td className="right">
                                                        <span className="text-dark">
                                                            {currencyFormat(
                                                                invoiceDetails
                                                                    .cartValues
                                                                    .total_amount
                                                            )}
                                                        </span>
                                                    </td>
                                                </tr>
                                                {invoiceDetails.cartValues
                                                    .total_deposit ? (
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                {t(
                                                                    'bid_deposit'
                                                                )}
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                -{' '}
                                                                {currencyFormat(
                                                                    invoiceDetails
                                                                        .cartValues
                                                                        .total_deposit
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ) : null}

                                                {invoiceDetails.cartValues
                                                    .total_paid ? (
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                {t(
                                                                    'total_paid'
                                                                )}
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {currencyFormat(
                                                                    invoiceDetails
                                                                        .cartValues
                                                                        .total_paid
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ) : null}

                                                {invoiceDetails.cartValues
                                                    .total_due_amount ? (
                                                    <tr>
                                                        <td
                                                            className="left"
                                                            align="right"
                                                        >
                                                            <span className="text-dark">
                                                                {t(
                                                                    'pending_amount'
                                                                )}
                                                            </span>
                                                        </td>
                                                        <td className="right">
                                                            <span className="text-dark">
                                                                {currencyFormat(
                                                                    invoiceDetails
                                                                        .cartValues
                                                                        .total_due_amount
                                                                )}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <h4 className="thankText">
                        {t('thank_you_for_shopping_with_us')}
                    </h4> */}
                </div>
            )}

            <CustomDialog
                open={addMoreItems}
                function={() => setAddMoreItems(false)}
                title={t('add_item')}
                disableBackdropClick
                className="addItemsModal"
                handleClose={handleCloseMoreItems}
            >
                {addMoreItemsFormik.values.product_title ? (
                    <>
                        <h5>{addMoreItemsFormik.values.product_title}</h5>
                    </>
                ) : null}
                <div className="row wnrDialog mb-3">
                    {Object.values(mapData(addMoreItemsFields))}
                </div>
                <div className="scanLpn">
                    <Divider />
                    <span className="or">OR</span>
                </div>
                <Button className="scanLpnBtn" onClick={handleScanProduct}>
                    <span className="material-icons">photo_camera</span> Scan
                    LPN Number
                </Button>
                <div className="row wnrDialog mb-3">
                    {Object.values(mapData(itemsQuantityField))}
                </div>
                <div className="actionWrapper">
                    <Button
                        id="add_items_cancel"
                        onClick={() => handleCloseMoreItems()}
                    >
                        Cancel
                    </Button>
                    <PrimaryButton
                        disabled={!addMoreItemsFormik.isValid}
                        onClick={() => addMoreItemsFormik.handleSubmit()}
                        type="button"
                        label={'Add'}
                    />
                </div>
            </CustomDialog>
            <BarCodeScan
                scanToggle={scanToggle}
                changeScanDialogStatus={changeScanDialogStatus}
                setDecodedBarcode={setDecodedBarcode}
            />
        </Layout>
        // </FullScreenPopup>
    )
}

export default InvoiceView
